

import { useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { registerUser } from "../../api/authServices";
import Swal from "sweetalert2";
export default function SignUp() {
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
const navigate = useNavigate();
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value,
    });

    // Remove error while typing
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Submit form
  const handleSubmit = async () => {
    const newErrors = {};

    // First Name
    if (!form.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    // Last Name
    if (!form.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    // Email
    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
        form.email
      )
    ) {
      newErrors.email = "Invalid email address";
    }

    // Password
    if (!form.password.trim()) {
      newErrors.password = "Password is required";
    } else if (form.password.length < 6) {
      newErrors.password =
        "Password must be at least 6 characters";
    }

    // Stop if errors
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      const payload = {
        first_name: form.firstName.trim(),
        last_name: form.lastName.trim(),
        email: form.email.trim(),
        password: form.password.trim(),
      };

      const data = await registerUser(payload);

      await Swal.fire({
  toast: true,
  position: "top-end",
  icon: "success",
  title: "Registration successful",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  background: "#0f172a",
  color: "#fff",
});

navigate("/signin");
      console.log("Registered:", data);

      setForm({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
      });

    } catch (err) {
      setErrors({
        api:
          err.response?.data?.message ||
          "Registration failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-cover bg-center px-4"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1920&auto=format&fit=crop')",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Card */}
      <div className="relative z-10 w-full max-w-lg bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl shadow-2xl p-8">

        {/* Title */}
        <div className="mb-8 text-center">
          <h1 className="text-4xl font-bold text-white mb-2">
            Create Account
          </h1>

          <p className="text-slate-200">
            Join your CRM workspace today
          </p>
        </div>

        {/* Error */}
        {errors.api && (
          <div className="mb-4 bg-red-500/20 border border-red-400 text-red-100 px-4 py-3 rounded-xl text-sm">
            {errors.api}
          </div>
        )}

        {/* Name Fields */}
        <div className="grid grid-cols-2 gap-4 mb-5">

          <div>
            <label className="block text-sm text-slate-200 mb-2">
              First Name
            </label>

            <input
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              placeholder="John"
              className={`w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 focus:outline-none focus:ring-2 ${errors.firstName
                  ? "border border-red-400 focus:ring-red-400"
                  : "border border-white/20 focus:ring-blue-400"
                }`}
            />

            {errors.firstName && (
              <p className="text-red-300 text-sm mt-2">
                {errors.firstName}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm text-slate-200 mb-2">
              Last Name
            </label>

            <input
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              placeholder="Doe"
              className={`w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 focus:outline-none focus:ring-2 ${errors.lastName
                  ? "border border-red-400 focus:ring-red-400"
                  : "border border-white/20 focus:ring-blue-400"
                }`}
            />

            {errors.lastName && (
              <p className="text-red-300 text-sm mt-2">
                {errors.lastName}
              </p>
            )}
          </div>
        </div>

        {/* Email */}
        <div className="mb-5">
          <label className="block text-sm text-slate-200 mb-2">
            Email
          </label>

          <input
            name="email"
            value={form.email}
            onChange={handleChange}
            type="email"
            placeholder="john@example.com"
            className={`w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 focus:outline-none focus:ring-2 ${errors.email
                ? "border border-red-400 focus:ring-red-400"
                : "border border-white/20 focus:ring-blue-400"
              }`}
          />

          {errors.email && (
            <p className="text-red-300 text-sm mt-2">
              {errors.email}
            </p>
          )}
        </div>

        {/* Password */}
        <div className="relative mb-6">
          <label className="block text-sm text-slate-200 mb-2">
            Password
          </label>

          <input
            name="password"
            value={form.password}
            onChange={handleChange}
            type={showPassword ? "text" : "password"}
            placeholder="Create password"
            className={`w-full px-4 py-3 rounded-xl bg-white/10 text-white placeholder-slate-300 focus:outline-none focus:ring-2 ${errors.password
                ? "border border-red-400 focus:ring-red-400"
                : "border border-white/20 focus:ring-blue-400"
              }`}
          />

          {errors.password && (
            <p className="text-red-300 text-sm mt-2">
              {errors.password}
            </p>
          )}

          <button
            type="button"
            onClick={() =>
              setShowPassword(!showPassword)
            }
            className="absolute right-4 top-[45px] text-slate-300"
          >
            {showPassword ? "🙈" : "👁"}
          </button>
        </div>

        {/* Button */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-xl font-medium transition duration-300 disabled:opacity-50"
        >
          {loading ? "Creating Account..." : "Sign Up"}
        </button>

        {/* Redirect */}
        <div className="mt-6 text-center text-sm text-slate-200">
          Already have an account?{" "}
          <Link
            to="/signin"
            className="text-blue-300 hover:text-white font-medium"
          >
            Sign In
          </Link>
        </div>
      </div>
    </div>
  );
}